import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const usePlaceholderStyles = makeStyles<
  Theme,
  {
    textWidth?: string;
    textFullWidth?: boolean;
    textFontSize?: number;
    avatarDiameter?: number;
    timelineDividerPipeHeight?: number;
    boxWidth?: string;
    boxHeight?: string;
    boxBorderColor?: string;
    boxBorderRadius?: string;
    boxBackgroundColor?: string;
  }
>({
  '@keyframes pulse': {
    '0%': {
      opacity: 0.1
    },
    '100%': {
      opacity: 0.9
    }
  },
  pulse: {
    animation: '$pulse 1.5s ease-in alternate infinite'
  },
  text: {
    width({ textWidth = '100px', textFullWidth = false }) {
      return textFullWidth ? '100%' : textWidth;
    },
    height({ textFontSize = 16 }) {
      return `${textFontSize}px`;
    },
    backgroundColor: 'lightgrey',
    margin: '8px 0'
  },
  avatar: {
    backgroundColor: 'lightgrey',
    width({ avatarDiameter }) {
      return `${avatarDiameter}px`;
    },
    height({ avatarDiameter }) {
      return `${avatarDiameter}px`;
    }
  },
  timelineDividerPipe: {
    borderLeft: `0.2rem solid lightgrey`,
    height({ timelineDividerPipeHeight = 16 }) {
      return `${timelineDividerPipeHeight}px`;
    },
    marginLeft: '1.5rem',
    paddingTop: '0.4rem',
    paddingBottom: '1rem',
    paddingLeft: '1rem'
  },
  box: {
    width({ boxWidth = '100px' }) {
      return boxWidth;
    },
    height({ boxHeight = '100px' }) {
      return boxHeight;
    },
    margin: '8px 0',
    padding: '8px',
    border: ({ boxBorderColor = 'white' }) => `1px solid ${boxBorderColor}`,
    borderRadius({ boxBorderRadius = '0' }) {
      return boxBorderRadius;
    },
    backgroundColor({ boxBackgroundColor = 'white' }) {
      return boxBackgroundColor;
    }
  }
});
